import React from 'react'
import HeaderImage from '../assets/images/Header.jpg'

const Repair = () => {
  return (
    <div className="min-h-screen bg-transparent pt-20 overflow-x-hidden">
      <div className="max-w-[1440px] mx-auto px-1 sm:px-2 md:px-4 py-12">
        {/* Başlık Bölümü */}
        <div 
          className="text-white p-8 rounded-lg mb-8 relative overflow-hidden"
          style={{
            backgroundImage: `url(${HeaderImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-40"></div>
          <h1 className="text-4xl font-bold text-center relative z-10">Tamir / Bakım</h1>
        </div>
        
        <div className="bg-white rounded-lg shadow-lg p-2 sm:p-4 md:p-6 lg:p-8 mb-8 relative z-10">
            <p className="text-lg leading-relaxed text-center mb-4">
              Servo Sürücü, Motor, PLC ve HMI'lara profesyonel şekilde tamir hizmeti sağlamaktayız.
            </p>
            <p className="text-lg leading-relaxed text-center mb-4">
              Bize ulaştığınız ilk andan son ana kadar size en kısa zamanda en kaliteli hizmeti sunmak için buradayız.
            </p>
            <p className="text-lg leading-relaxed text-center mb-4">
              Ekibimizde alanında uzman, yıllarını servo sürücü, motor, HMI ve PLC vb. endüstriyel ürünleri tamir etmiş ve yazılımından (program/parametre) devreye alınmasına kadar birçok işlemde tecrübe kazanmış arkadaşlarımız sizlere en iyi hizmeti vereceklerdir.
            </p>
            <p className="text-lg leading-relaxed text-center">
              Marka fark etmeksizin tecrübemizden faydalanabilirsiniz.
            </p>
        </div>

        {/* Uzman Olduğumuz Markalar */}
        <div 
          className="text-white p-6 rounded-lg mb-12 relative overflow-hidden"
          style={{
            backgroundImage: `url(${HeaderImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-40"></div>
          <h2 className="text-xl font-semibold text-center relative z-10">
            Tamirinde Uzman Olduğumuz Bazı Marka ve Modeller
          </h2>
        </div>

        {/* KOLLMORGEN SERVO SÜRÜCÜLER */}
        <div className="bg-white rounded-lg shadow-lg p-2 sm:p-4 md:p-6 lg:p-8 mb-8 relative z-10">
          <div className="grid lg:grid-cols-2 gap-2 sm:gap-4 md:gap-6 lg:gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-[#2E3192] mb-4">KOLLMORGEN SERVO SÜRÜCÜLER</h3>
              <h4 className="text-xl font-semibold text-[#2E3192] mb-6">AKD SERİSİ</h4>
              
              <div className="space-y-2 mb-6">
                <p>AKD-x00306 / AKD-x00307....E000,0091,0069</p>
                <p>AKD-x00606 / AKD-x00607....E000,0091,0069</p>
                <p>AKD-x01206 / AKD-x01207....E000,0091,0069</p>
                <p>AKD-x02406 / AKD-x02407....E000,0091,0069</p>
                <p>AKD-x04807....E000,0091</p>
              </div>
              
              <p className="text-sm text-gray-600">
                x = P (Position indexer), M (Motion Control), B (Base, Synqnet only), T (BASIC)
              </p>
            </div>
            <div className="flex justify-center">
              <img 
                src={require('../assets/images/tamir-bakim/AKD_Large_4.png.webp')} 
                alt="AKD Serisi" 
                className="w-full max-w-[280px] sm:max-w-[320px] md:max-w-[380px] lg:max-w-[400px] h-44 sm:h-60 md:h-76 lg:h-96 rounded-lg"
              />
            </div>
          </div>
        </div>

        {/* KOLLMORGEN PROGRAMLANABİLİR KONTROLÜRLER */}
        <div className="bg-white rounded-lg shadow-lg p-2 sm:p-4 md:p-6 lg:p-8 mb-8 relative z-10">
          <div className="grid lg:grid-cols-2 gap-2 sm:gap-4 md:gap-6 lg:gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-[#2E3192] mb-6 max-w-[600px]">KOLLMORGEN PROGRAMLANABİLİR KONTROLCÜRLER</h3>
              
              <div className="space-y-4">
                <div>
                  <h4 className="text-lg font-semibold text-[#2E3192] mb-2">PDMM Programlanabilir Servo Sürücü</h4>
                  <p>AKD-Mxxxx-MCEC / AKD-Mxxxx-M1EC / AKD-Mxxxx-M2EC</p>
                </div>
                
                <div>
                  <h4 className="text-lg font-semibold text-[#2E3192] mb-2">PCMM Programlanabilir Kontrolcü</h4>
                  <p>PCMM2G Programlanabilir Kontrolcü (2. Nesil)</p>
                </div>
              </div>
            </div>
            <div className="flex justify-center gap-1">
              <img 
                src={require('../assets/images/tamir-bakim/pdmm.jpg')} 
                alt="PDMM" 
                className="w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-56 object-contain rounded-lg"
              />
              <img 
                src={require('../assets/images/tamir-bakim/pcmm.jpg')} 
                alt="PCMM" 
                className="w-32 h-32 sm:w-40 sm:h-40 md:w-[800px] md:h-56 rounded-lg"
              />
              <img 
                src={require('../assets/images/tamir-bakim/pcmm2G.png')} 
                alt="PCMM2G" 
                className="w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-56 object-contain rounded-lg"
              />
            </div>
          </div>
        </div>

        {/* SERVOSTAR 700 SERİSİ */}
        <div className="bg-white rounded-lg shadow-lg p-2 sm:p-4 md:p-6 lg:p-8 mb-8">
          <div className="grid lg:grid-cols-2 gap-2 sm:gap-4 md:gap-6 lg:gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-[#2E3192] mb-4">SERVOSTAR 700 SERİSİ</h3>
              <p>Servo amplifier <br/>S70102, S70302, S70602,<br/> S71202, S7120S, S72402,<br/> S7240S, S74802, S77202</p>
            </div>
            <div className="flex justify-center">
              <img 
                src={require('../assets/images/tamir-bakim/S700-family-large_1.png.webp')} 
                alt="Servostar 700" 
                className="w-full max-w-[280px] sm:max-w-[320px] md:max-w-[380px] lg:max-w-[400px] h-44 sm:h-60 md:h-76 lg:h-96 rounded-lg"
              />
            </div>
          </div>
        </div>

        {/* SERVOSTAR 600 SERİSİ */}
        <div className="bg-white rounded-lg shadow-lg p-2 sm:p-4 md:p-6 lg:p-8 mb-8">
          <div className="grid lg:grid-cols-2 gap-2 sm:gap-4 md:gap-6 lg:gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-[#2E3192] mb-4">SERVOSTAR 600 SERİSİ</h3>
              
              <div className="grid md:grid-cols-2 gap-4 mb-4">
                <div className="space-y-2">
                  <p>SERVOSTAR 601 S60100-NA</p>
                  <p>SERVOSTAR 601-AS S60101-NA</p>
                  <p>SERVOSTAR 603 S60300-NA</p>
                  <p>SERVOSTAR 603-AS S60301-NA</p>
                  <p>SERVOSTAR 606 S60600-NA</p>
                  <p>SERVOSTAR 606-AS S60601-NA</p>
                </div>
                <div className="space-y-2">
                  <p>SERVOSTAR 610 S61000-NA</p>
                  <p>SERVOSTAR 610-AS S61001-NA</p>
                  <p>SERVOSTAR 610-30 S610-3000-NA</p>
                  <p>SERVOSTAR 610-30-AS S610-3001-NA</p>
                  <p>SERVOSTAR 614 S61400-NA</p>
                  <p>SERVOSTAR 614-AS S61401-NA</p>
                </div>
              </div>
              
              <div className="space-y-2 mb-4">
                <p>SERVOSTAR 620 S62000-NA / SERVOSTAR 620-AS S62001-NA</p>
                <p>SERVOSTAR 640 S64001-NA</p>
                <p>SERVOSTAR 670 S67001-NA</p>
              </div>
              
              <p className="text-sm text-gray-600 italic">
                Kollmorgen marka diğer servis dışı sürücüler (bilgi için arayınız).
              </p>
            </div>
            <div className="flex justify-center">
              <img 
                src={require('../assets/images/tamir-bakim/S600-Serviced_Large_4.png.webp')} 
                alt="Servostar 600" 
                className="w-full max-w-[280px] sm:max-w-[320px] md:max-w-[380px] lg:max-w-[400px] h-44 sm:h-60 md:h-76 lg:h-96 rounded-lg"
              />
            </div>
          </div>
        </div>

        {/* SERVOSTAR 400 SERİSİ */}
        <div className="bg-white rounded-lg shadow-lg p-2 sm:p-4 md:p-6 lg:p-8 mb-8">
          <div className="grid lg:grid-cols-2 gap-2 sm:gap-4 md:gap-6 lg:gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-[#2E3192] mb-4">SERVOSTAR 400 SERİSİ</h3>
              
              <div className="space-y-2 mb-4">
                <p>SERVOSTAR 403M-xx</p>
                <p>SERVOSTAR 406M-xx</p>
                <p>SERVOSTAR 443M-xx</p>
                <p>SERVOSTAR 446M-xx</p>
                <p>SERVOSTAR 403A-xx</p>
                <p>SERVOSTAR 406A-xx</p>
              </div>
              
              <p className="text-sm text-gray-600 italic">
                Kollmorgen marka diğer servis dışı sürücüler (bilgi için arayınız).
              </p>
            </div>
            <div className="flex justify-center">
              <img 
                src={require('../assets/images/tamir-bakim/s400.jpg')} 
                alt="Servostar 400" 
                className="w-full max-w-[400px] h-64 sm:h-80 md:h-96 object-contain rounded-lg"
              />
            </div>
          </div>
        </div>

        {/* SERVOSTAR 300 SERİSİ */}
        <div className="bg-white rounded-lg shadow-lg p-2 sm:p-4 md:p-6 lg:p-8 mb-8">
          <div className="grid lg:grid-cols-2 gap-2 sm:gap-4 md:gap-6 lg:gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-[#2E3192] mb-4">SERVOSTAR 300 SERİSİ</h3>
              
              <div className="space-y-2">
                <p>SERVOSTAR 303 S30361-xx</p>
                <p>SERVOSTAR 306 S30661-xx</p>
                <p>SERVOSTAR 310 S31061-xx</p>
                <p>SERVOSTAR 341 S30101-xx</p>
                <p>SERVOSTAR 343 S30301-xx</p>
                <p>SERVOSTAR 346 S30601-xx</p>
              </div>
            </div>
            <div className="flex justify-center">
              <img 
                src={require('../assets/images/tamir-bakim/S300_Large_6.png.webp')} 
                alt="Servostar 300" 
                className="w-full max-w-[280px] sm:max-w-[320px] md:max-w-[380px] lg:max-w-[400px] h-44 sm:h-60 md:h-76 lg:h-96 rounded-lg"
              />
            </div>
          </div>
        </div>

        {/* AKD-N & AKD-C */}
        <div className="bg-white rounded-lg shadow-lg p-2 sm:p-4 md:p-6 lg:p-8 mb-8">
          <div className="grid lg:grid-cols-2 gap-2 sm:gap-4 md:gap-6 lg:gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-[#2E3192] mb-4">AKD-N & AKD-C</h3>
              
              <p className="mb-4">Özel seri saha montajlı ürünler</p>
              <p className="mb-6">Tamiri, testi ve bu ürünlere dair her bilgiye hâkimiz.</p>
              
              <div className="space-y-2 mb-6">
                <p>AKD-N00307-xx</p>
                <p>AKD-N00607-xx</p>
                <p>AKD-N01207-xx</p>
                <p>AKD-C01007-xx</p>
              </div>
              
              <div>
                <h4 className="text-lg font-semibold text-[#2E3192] mb-2">AKD2G Tüm Seriler</h4>
              </div>
            </div>
            <div className="flex justify-center gap-2 sm:gap-3 md:gap-4">
              <img 
                src={require('../assets/images/tamir-bakim/AKD_CN_Gruppe_600x600_freigestellt.png')} 
                alt="AKD-N & AKD-C" 
                className="w-full max-w-[150px] sm:max-w-[180px] md:max-w-[200px] h-40 sm:h-48 md:h-56 lg:h-64 object-contain rounded-lg"
              />
              <img 
                src={require('../assets/images/tamir-bakim/AKD2G.jpg')} 
                alt="AKD2G" 
                className="w-full max-w-[150px] sm:max-w-[180px] md:max-w-[200px] h-40 sm:h-48 md:h-56 lg:h-64 object-contain rounded-lg"
              />
            </div>
          </div>
        </div>

        {/* GEFRAN MARKA SÜRÜCÜLER */}
        <div className="bg-white rounded-lg shadow-lg p-2 sm:p-4 md:p-6 lg:p-8 mb-8">
          <div className="grid lg:grid-cols-2 gap-2 sm:gap-4 md:gap-6 lg:gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-[#2E3192] mb-4">GEFRAN MARKA SÜRÜCÜLER</h3>
              
              <div className="space-y-2 mb-4">
                <p>XVy-EV 10306</p>
                <p>XVy-EV 10408</p>
                <p>XVy-EV 10612</p>
                <p>XVy-EV 20816</p>
                <p>XVy-EV 21020</p>
                <p>XVy-EV 21530</p>
                <p>XVy-EV 32040</p>
                <p>XVy-EV 32550</p>
                <p>XVy-EV 43366</p>
                <p>XVy-EV 43570</p>
              </div>
              
              <p className="text-sm text-gray-600 italic">
                ve diğer tüm sürücüler (bilgi için arayınız)
              </p>
            </div>
            <div className="flex justify-center gap-2 sm:gap-3 md:gap-4">
              <img 
                src={require('../assets/images/tamir-bakim/XVY-4TUS.jpg')} 
                alt="XVY-4TUS" 
                className="w-full max-w-[150px] sm:max-w-[180px] md:max-w-[200px] h-40 sm:h-48 md:h-56 lg:h-64 object-contain rounded-lg"
              />
              <img 
                src={require('../assets/images/tamir-bakim/XVY-EV.jpg')} 
                alt="XVY-EV" 
                className="w-full max-w-[150px] sm:max-w-[180px] md:max-w-[250px] h-40 sm:h-48 md:h-56 lg:h-64 object-contain rounded-lg"
              />
            </div>
          </div>
        </div>

        {/* HMI / PANEL / END. PC TAMİRİ */}
        <div className="bg-white rounded-lg shadow-lg p-2 sm:p-4 md:p-6 lg:p-8 mb-8">
          <div className="grid lg:grid-cols-2 gap-2 sm:gap-4 md:gap-6 lg:gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-[#2E3192] mb-4">HMI / PANEL / END. PC TAMİRİ</h3>
              <p>EXOR Etopxx, Ex, Esmartxx JMobile Runtime vb. tüm ürünler için iletişime geçebilirsiniz.</p>
            </div>
            <div className="flex justify-center">
              <img 
                src={require('../assets/images/tamir-bakim/Etop507.jpg')} 
                alt="HMI Panel" 
                className="w-full max-w-[280px] sm:max-w-[320px] md:max-w-[380px] lg:max-w-[400px] h-44 sm:h-60 md:h-76 lg:h-96 rounded-lg"
              />
            </div>
          </div>
        </div>

        {/* KOLLMORGEN SERVO MOTORLAR */}
        <div className="bg-white rounded-lg shadow-lg p-2 sm:p-4 md:p-6 lg:p-8 mb-8">
          <div className="grid lg:grid-cols-2 gap-2 sm:gap-4 md:gap-6 lg:gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-[#2E3192] mb-4">KOLLMORGEN SERVO MOTORLAR</h3>
              
              <div className="space-y-4">
                <div>
                  <p className="mb-2">AKM1xx-xxxx ....... AKM8xx-xxxx tüm AKM serisi motorlar</p>
                  <p className="text-sm text-gray-600 italic">(Hybrid haberleşmeli motorlar uzmanlığımız dahilindedir)</p>
                </div>
                
                <div>
                  <p className="mb-2">AKM2G-1xx-xxxx ...... AKM2G-7xx-xxxx tüm AKM2G serisi motorlar</p>
                  <p className="text-sm text-gray-600 italic">(Hybrid haberleşmeli motorlar uzmanlığımız dahilindedir)</p>
                </div>
                
                <div>
                  <p className="mb-2">Eski seri 6SM, DBL, DBK vb. tüm motorlar.</p>
                </div>
                
                <div>
                  <p className="mb-2">Özellikle SFD-SFD3 ve HiperFace DSL Hybrid teknolojisiyle üretilmiş motorlarda enkoder değişimi sonrası adaptasyon konusunda uzmanız.</p>
                  <p className="text-sm text-gray-600 italic">Motorlara ait özel enkoderler stoğumuzda bulunmaktadır.</p>
                </div>
              </div>
            </div>
            <div className="flex justify-center gap-2 sm:gap-3 md:gap-4">
              <img 
                src={require('../assets/images/tamir-bakim/AKM_Series.jpg')} 
                alt="AKM Series" 
                className="w-full max-w-[150px] sm:max-w-[180px] md:max-w-[250px] h-40 sm:h-48 md:h-56 lg:h-64 object-contain rounded-lg"
              />
              <img 
                src={require('../assets/images/tamir-bakim/AKM2G_Series.jpg')} 
                alt="AKM2G Series" 
                className="w-full max-w-[150px] sm:max-w-[180px] md:max-w-[200px] h-40 sm:h-48 md:h-56 lg:h-64 object-contain rounded-lg"
              />
            </div>
          </div>
        </div>

        {/* GEFRAN SERVO MOTORLAR */}
        <div className="bg-white rounded-lg shadow-lg p-2 sm:p-4 md:p-6 lg:p-8 mb-8">
          <div className="grid lg:grid-cols-2 gap-2 sm:gap-4 md:gap-6 lg:gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-[#2E3192] mb-4">GEFRAN SERVO MOTORLAR</h3>
              <p className="mb-2">Tüm SBM serisi motorlar</p>
              <p className="text-sm text-gray-600 italic">Bu motorlar yerine muadil motor çalışması da yapılmaktadır.</p>
            </div>
            <div className="flex justify-center">
              <img 
                src={require('../assets/images/tamir-bakim/SBM.jpg')} 
                alt="Gefran SBM" 
                className="w-full max-w-[400px] h-64 sm:h-80 md:h-96 object-contain rounded-lg"
              />
            </div>
          </div>
        </div>

        {/* LAFERT SERVO MOTORLAR */}
        <div className="bg-white rounded-lg shadow-lg p-2 sm:p-4 md:p-6 lg:p-8 mb-8">
          <div className="grid lg:grid-cols-2 gap-2 sm:gap-4 md:gap-6 lg:gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-[#2E3192] mb-4">LAFERT SERVO MOTORLAR</h3>
              <p className="mb-2">Tüm LAFERT serisi motorlar</p>
              <p className="text-sm text-gray-600 italic mb-4">Bu motorlar yerine muadil motor çalışması da yapılmaktadır.</p>
              <p className="text-sm text-gray-600 italic">Markadan bağımsız tüm servo motor tamirleri hakkında bilgi almak için bizimle iletişime geçebilirsiniz.</p>
            </div>
            <div className="flex justify-center">
              <img 
                src={require('../assets/images/tamir-bakim/Lafert.png')} 
                alt="Lafert Motors" 
                className="w-full max-w-[400px] h-64 sm:h-80 md:h-96 object-contain rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Repair
